export default "__VITE_ASSET__DUQ$aGBN__"